export default __webpack_public_path__ + "static/upload-source-file-b285c6703f80ae2c96f5465c0be0f870.gif";